import axios from 'axios';

export default {
    methods: {
        async menuRolesAsignados(params, ok, err) {
            try {
                let r = await axios.post('menu/roles-asignados', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async menuAsignarRoles(params, ok, err) {
            try {
                let r = await axios.post('menu/asignar-roles', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/auth/menu.js